/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedPromoCode_viewer = {
    readonly activePromotion: {
        readonly code: string | null;
    } | null;
    readonly " $refType": "PdpSharedPromoCode_viewer";
};
export type PdpSharedPromoCode_viewer$data = PdpSharedPromoCode_viewer;
export type PdpSharedPromoCode_viewer$key = {
    readonly " $data"?: PdpSharedPromoCode_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPromoCode_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'ac1d609dd21511ac5849025a07a179b8';
export default node;
